var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00319c",
    fillRule: "evenodd",
    d: "M.3 0h17.8v40H.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde00",
    fillRule: "evenodd",
    d: "M18.1 0H36v40H18z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    fillRule: "evenodd",
    d: "M35.9 0h17.8v40H35.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1900",
    fillRule: "evenodd",
    d: "m30.4 26.7 2 3q.2 0 0 .4v.6q.4.5.7.3l1.5-1q.4 0 0-.6c0-.2-.5-.4-.6-.3q-.3 0-.4-.2l-2-3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m30.4 26.7 2 3q.2 0 0 .4v.6q.4.5.7.3l1.5-1q.4 0 0-.6c0-.2-.5-.4-.6-.3q-.3 0-.4-.2l-2-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a77b3b",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M31.2 24.6c.9 1 1.2 2.2.7 2.7q-1 .5-2.6-1.2c-1-1-1.2-2.2-.7-2.6s1.7.1 2.6 1.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1900",
    fillRule: "evenodd",
    d: "m22.2 25.5-1.8 3q-.1.4-.4.3l-.7.3q-.2.6.1.7l1.6.9q.3 0 .7-.3l-.1-.7q-.2-.2 0-.5l1.8-3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m22.2 25.5-1.8 3q-.1.4-.4.3l-.7.3q-.2.6.1.7l1.6.9q.3 0 .7-.3l-.1-.7q-.2-.2 0-.5l1.8-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a77b3b",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M28 23.4h-1.7s-.5 3-1 4c-.6 1.4-2.5 2.6-2.5 2.6l1.5.6s1.8-.4 2-2.6c.2 2.2-1.2 3.2-1.2 3.2s2 .5 2 1.9c0-1.4 2-2 2-2s-1-1-1.2-3c.4 2 2 2.4 2 2.5l1.5-.6s-1.8-1.2-2.5-2.5c-.5-1.1-1-4-1-4.1Zm-7-9.7 3 1c1 0 2.1-1 2.1-2 0-2.2-.8-3-1-3l.4-.3-.6-.6s.2-1 2.2-1 2 1 2 2-1 1-1 2.9c0 1 1 2 2 2l3.1-1v9.7H21z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.7 14 .2.6.2-.6.2.6.4-.6.2.7.2-.7.3.7.3-.7.2.6.2-.6m-1.6-2-.4 2m.6-2v2m.4-2v2m.4-2 .2 2m.2-2 .2 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a77b3b",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M19 7.8c-2 1-2 3-2 4v19.4s0-1.1 1-2l1-1 1-1c.7-.6 1-1.9 1-2.8V10.7s0-1-2-2.9Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m21 11.7-1-1-1 1-1-1-1 1m4 1-1 1-1-1-1 1-1-1m4 2.9-1-1-1 1-1-1-1 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M20 10.7v16.6m-1-15.6v16.5m-1-17.4v18.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a77b3b",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M35.3 7.8c2 1 2 3 2 4v19.4s-.1-1.1-1-2l-1-1-1-1c-.8-.6-1-1.9-1-2.8V10.7s0-1 2-2.9Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m33.2 11.7 1-1 1 1 1-1 1 1m-4 1 1 1 1-1 1 1 1-1m-4 2.9 1-1 1 1 1-1 1 1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M34.2 10.7v16.6m1.1-15.6v16.5m1-17.4v18.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a77b3b",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M24.4 25.2q-1 2-2 1.8c-.7-.2-.8-1.4-.2-2.7.5-1.2 1.5-2 2-1.8.7.3.8 1.5.2 2.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M21 14.6h12.2v5.9H21z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#564dff",
    fillRule: "evenodd",
    d: "M21 20.5h12.2v2.9c0 2-3 2-6 3.9-3.1-2-6.2-2-6.2-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0",
    strokeWidth: 0.2,
    d: "M21 14.6h12.2v8.8c0 2-3 2-6 3.9-3.1-2-6.2-2-6.2-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.9 15s-2 1.5-2 2.8c0 1.4 2 1.8 2 1.8s-.6 0-.6 1.9c0 .9 2.1.4 2.1.9v2.3c0 .4-1.4 0-1.4.4 0 .3 1 1.4 2.1 1.4 1 0 2.1-1.1 2.1-1.4 0-.4-1.4 0-1.4-.4v-2.3c0-.5 2.2 0 2.2-1 0-1.8-.8-1.8-.8-1.8s2.2-.4 2.2-1.8-2-2.8-2-2.8 1 2 1 2.8c0 .5-.4 1.4-1.9 1.4 0 0-.3-.5-.7 0 0 0-.4-.5-.7 0 0 .1-.3-.5-.7 0-.2.1-.3-.5-.7 0-.7 0-2.1-.5-2.1-1.4s1.3-2.8 1.3-2.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25 23.2c-.2 0 .1 1.6.2 1.6h1.1l-.1-1.5c-.1-.1-1.2-.2-1.3-.1Zm4.3 0c.2 0-.2 1.6-.3 1.6h-1l.1-1.5c.2-.1 1.2-.2 1.3-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m26.4 22.6-.2.4-.6.2-.5-.2-.2-.4.2-.3.5-.2.6.2zm2.9 0q0 .3-.2.4l-.5.2-.5-.2q-.3 0-.3-.4l.3-.3.5-.2q.3 0 .5.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M28.4 25.6q0 .2-.4.3-.3 0-.3-.3t.3-.2zm-1.9 0q0 .2-.3.3-.4 0-.4-.3l.4-.2q.3 0 .3.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27.1 18.3-.4-.5H26v-.6l-.5-.4.6-.4-.1-.7h.7l.4-.5.5.6.7-.1-.1.7.5.4-.5.4v.7l-.7-.1zm3.1 2.2 1.2.6 1.2-.6-1.2-.6zm-8.8 0 1.2.6 1.3-.6-1.3-.6zM32 24q-.7-.4-1.3 0-.6.2-.8 1.1-.4-1.1.5-1.6h1l.7.4Zm-8.3-1.2q0 .2-.2.3H23l-.2-.3q0-.2.2-.3h.5zm-.5 1.4v.2a.4.4 0 0 1-.6 0l-.2-.2.2-.3h.5zm-.2-.8v.3a.4.4 0 0 1-.6 0l-.2-.3.2-.3h.5zm1 .8v.2a.4.4 0 0 1-.6 0l-.2-.2.2-.3h.5zm.3-.8-.2.3h-.5l-.2-.3.2-.3h.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m23.7 23.6-.2.2H23l-.2-.2.2-.3.2-.1.3.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da4500",
    fillRule: "evenodd",
    d: "M25.1 10c-1 0-1.1.2-1.6.4 0-.5 1.2-1 2.2-1q0 .5-.6.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cac9c7",
    fillRule: "evenodd",
    d: "M26.7 9q0 .4-.4.4a.4.4 0 0 1-.4-.4q0-.4.4-.4t.4.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.4 7.6v.6h1v3h.7v-3h1v-.6h-1V7h-.7v.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da4500",
    fillRule: "evenodd",
    d: "M25.7 9.4q-1.3 0-2.5.3 0-1.1 2-1.3c.2 0 .5.7.5 1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008500",
    fillRule: "evenodd",
    d: "M15.1 19.7q-.5-1 .2-.1l6.3 11.9h-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008f00",
    fillRule: "evenodd",
    d: "M19.4 27.5c0-.9-1.6-1.8-1.7-1.7q0 .2.5.8-1-.5-1.3-.4c0 .2 1 .6 1 .8l-.7.2c0 .1 2 1.2 2.2.3M17.7 25c.1-1-1.5-1.9-1.6-1.8 0 0 .1.6.4.8-.5-.3-1.2-.5-1.2-.3s1 .6 1 .7c0 .2-.7.1-.7.3 0 0 2 1 2.1.3m-1.2-2.4c0-.9-1.5-1.8-1.6-1.7l.4.8-1.2-.4c0 .2 1 .6 1 .8l-.7.2c0 .1 2 1.2 2.1.3m-1.2-2.5c0-.9-1.6-1.8-1.6-1.8s0 .6.4.9l-1.2-.4c0 .2.9.6 1 .8 0 0-.7 0-.7.2 0 .1 2 1.1 2.1.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008f00",
    fillRule: "evenodd",
    d: "M15.7 20c.8-.5.6-2.3.6-2.3q-.3.1-.5.8-.2-1-.4-1.1c-.2 0 0 1 0 1.2-.2 0-.6-.5-.7-.4s.3 2.2 1 1.8m1.1 2.2c1-.2 1.4-2 1.4-2q-.3 0-.8.6.3-1 0-1.2c-.2 0-.3 1-.4 1.1-.2 0-.4-.6-.5-.5s-.5 2.2.3 2m1.4 2.3c.8-.4.8-2.2.7-2.3q-.2.1-.5.8 0-1-.3-1.2c-.2 0 0 1-.2 1.2 0 .1-.4-.5-.5-.4s0 2.2.8 1.9m1.5 3c.8-.4 1-2.2 1-2.2q-.4 0-.7.7 0-1-.2-1.2c-.2 0-.1 1-.3 1.2 0 0-.4-.6-.5-.5s-.2 2.2.7 2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M21.6 30.5q-.6.6-1.6.1-1-.7-.7-1.3t1.5 0q1 .6.8 1.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    d: "m38.1 18 .1-.3.3.1.1-.2h.3v.3l.2.1v.3l-.4-.1-.3.7-.3-.1.3-.7zm-.6 2.5h.3l-3.1 8.1h-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    fillRule: "evenodd",
    d: "m34.3 28.4.6.1-.9 2.3-.6-.2zm3.4-9.4 1 .3c.5.2-.8 1.5-.8 1.5l-.6-.2s-.1-1.8.4-1.6m.9 0q0 .2-.4.1-.3 0-.2-.3h.3q.3 0 .3.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.8 29.5q.3.7-.7 1.4t-1.6 0c-.2-.3 0-1 .7-1.3q1-.6 1.6 0Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/md.6b1a8e15e6fd5d592e39cd914373cdae.svg";
export { ForwardRef as ReactComponent };